export enum USER_ACTION_TYPES {
  SET_CURRENT_USER = 'user/SET_CURRENT_USER',
  CHECK_LOGIN_USER = 'user/CHECK_LOGIN',
  CHECKING_LOGIN_USER = 'user/CHECKING_LOGIN',
  LOGOUT_CURRENT_USER = 'user/LOGOUT_USER'
};

